var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stamp-container"},[_c('span',{attrs:{"id":"stamp-text"}},[_vm._v(_vm._s(_vm.month)+" "+_vm._s(_vm.description))]),_c('img',{attrs:{"src":"/assets/images/device-stamp.svg","alt":"promo-stamp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }